import React, { useEffect, useState } from 'react'
import {
  CModal,
  CModalBody,
  CModalFooter,
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CFormLabel,
  CFormInput,
  CButton,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CModalHeader,
  CModalTitle,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CFormTextarea,
  CBadge,
} from '@coreui/react'
import { Plus, Trash } from 'lucide-react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Select from 'react-select'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat'
import Graytextarea from '../../components/Graytextarea'
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api'
import toast from 'react-hot-toast'
import { useIndexedDB } from '../../context/IndexedContext'
const PatientIncidentTreatments = ({ diagnosisName, showDataIfNoteIsFollowUp, setAddedNewIncident, patientID = '', noteID, noteStructureRef, isAllotedToProvider, patientDiagnosis }) => {
  const [visible, setVisible] = useState(false)
  const [allDiagnosis, setAllDiagnosis] = useState([])
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [allIncidents, setAllIncidents] = useState([])
  const [date, setDate] = useState('')

  const handleAddNewIncident = async () => {
    const findDiagnosisId = allDiagnosis?.find((item) => item.label === selectedDiagnosis)
    if (findDiagnosisId) {
      let data = await SaveQuestionProvider('GET', '', 'Incident', findDiagnosisId?.value, '')
      data = JSON.parse(data?.d)?.Data || []
      const allParsedData = data.flatMap((item) => {
        try {
          const parsed = JSON.parse(item.questionData)
          return Array.isArray(parsed) ? parsed : []
        } catch (err) {
          console.error('Invalid JSON in questionData:', item.questionData)
          return []
        }
      })

      let isoString
      if (date) {
        const [month, day, year] = date?.split('/')
        const dateToIso = new Date(`${year}-${month}-${day}`)
        isoString = dateToIso.toISOString()
      }
      setAllIncidents([...allIncidents, { diagnosis: findDiagnosisId?.label, date: isoString, incidents: allParsedData }])

      setVisible(false)
      setDate('')
      setSelectedDiagnosis(null)
    }
  }

  useEffect(() => {
    if (allDiagnosis.length > 0) {
      const getCurrentDiagnosisNmeOpt = allDiagnosis.find((item) => item.label === diagnosisName)
      setSelectedDiagnosis(getCurrentDiagnosisNmeOpt?.label || null)
    }
  }, [allDiagnosis])

  const handleDateChange = (e) => {
    setDate(e)
  }

  useEffect(() => {
    const incidentObj = noteStructureRef?.current?.incident
    if (!incidentObj) return

    const allKeys = Object.keys(incidentObj)

    const structuredIncidents = allKeys
      .map((key) => {
        const [diagnosis, date] = key.split('_')
        return {
          diagnosis,
          date,
          incidents: incidentObj[key],
        }
      })
      ?.filter((item) => item.diagnosis === diagnosisName)

    setAllIncidents(structuredIncidents)
  }, [noteStructureRef?.current])

  // fetch diagnosis
  const { getAllMasterDiagnosis } = useIndexedDB()
  const fetchDiagnosis = async () => {
    let diagnosisData = await getAllMasterDiagnosis()
    // let diagnosisData = await GetDiagnosisData("");
    diagnosisData = diagnosisData?.Data
    if (diagnosisData.length > 0) {
      const allDiagnosisOpt = diagnosisData.map((diagnosis) => {
        return {
          value: diagnosis.id,
          label: diagnosis.Name,
        }
      })
      setAllDiagnosis(allDiagnosisOpt)
    }
  }

  const handleDeleteIncident = (index) => {
    const updatedIncidents = allIncidents.filter((_, i) => i !== index)
    setAllIncidents(updatedIncidents)
  }

  useEffect(() => {
    fetchDiagnosis()
  }, [])

  const handleSave = async () => {
    allIncidents.forEach((item) => {
      const key = `${item.diagnosis}_${item.date}`
      noteStructureRef.current = {
        ...noteStructureRef.current,
        incident: {
          ...noteStructureRef.current.incident,
          [key]: item?.incidents || [],
        },
      }
    })
    setAddedNewIncident((p) => !p)
    toast.success('Saved')
  }

  return (
    <>
      <CAccordion className=" " flush>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <div className="d-flex gap-3 align-items-center">
              <h7 className="fw-light" style={{}}>
                <b>Incident</b>
              </h7>
              {/* {isAllotedToProvider && <CFormLabel
                                className="d-flex mt-2 flex-column align-items-center justify-content-center shadow "
                                onClick={(e) => {
                                    e.stopPropagation()
                                    e.preventDefault()
                                    setVisible((p) => !p)
                                }}
                                style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "20px",
                                    background: "var(--ui-color-primary, #2b7cd3)",
                                    cursor: "pointer",
                                }}
                            >
                                <Plus className="text-white" strokeWidth={2} size={15} />
                            </CFormLabel>} */}
            </div>
          </CAccordionHeader>
          <CAccordionBody>
            <CAccordion flush>
              {allIncidents.length > 0 ? (
                allIncidents.map((incident, index) => {
                  return (
                    <div>
                      <p className="p-0 m-0 " style={{ fontWeight: 600 }}>
                        {diagnosisName} -{' '}
                        {new Date(incident.date).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                        })}
                      </p>
                      <div className="p-2">
                        {incident?.incidents.length > 0 && (
                          <p className="" style={{ whiteSpace: 'pre-line' }}>
                            {incident?.incidents[0]?.freeRemark || ''}
                          </p>
                        )}
                        {incident.incidents &&
                          incident.incidents.length > 0 &&
                          incident.incidents
                            ?.filter((item) => item.answer)
                            ?.map((incidentItem, index) => {
                              return (
                                incidentItem.answer && (
                                  <div key={index}>
                                    <p className="p-0 m-0">
                                      {index + 1}. {incidentItem.label} : <span className="">{incidentItem.answer}</span>
                                    </p>
                                    <p className="p-0 m-0" style={{ whiteSpace: 'pre-line', color: '#707070', fontStyle: 'italic' }}>
                                      {incidentItem?.freeType}
                                    </p>
                                  </div>
                                )
                              )
                            })}
                      </div>
                    </div>
                  )
                })
              ) : (
                <div className="d-flex justify-content-start align-items-start text-muted">
                  <div
                    style={{
                      fontSize: '15px',
                      fontWeight: '600px',
                      color: 'gray',
                    }}
                  >
                    No Incident Exist
                  </div>
                </div>
              )}
            </CAccordion>
            <div className="d-flex align-items-center justify-content-center mt-2">{/* <CButton variant='outline' disabled={allIncidents.length === 0} onClick={handleSave} className='  w-'>Save</CButton> */}</div>
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>

      <CModal className="incident-modal" centered visible={visible} size="lg" alignment="center" onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>Add Incident</CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            height: '400px',
          }}
          className="d-flex  justify-content-center"
        >
          <div className="w-50 d-flex flex-column gap-3">
            {/* <Select
                            options={allDiagnosis}
                            onChange={(e) => setSelectedDiagnosis(e.label)}
                            value={
                                allDiagnosis.find((item) => item.label === selectedDiagnosis) || null
                            }
                        /> */}
            <CBadge className="p-3 text-start" textBgColor="light">
              {selectedDiagnosis}
            </CBadge>

            <div className="d-flex align-items-center gap-3">
              <CFormLabel className="fw-medium mb-0">Incident Date:</CFormLabel>
              {/* <CFormInput
                                                    type="date"
                                                    value={date}
                                                    onChange={(e) => handleDateChange(e)}
                                                    // disabled={type === "note" ? false : true}
                                                    style={{
                                                        width: "180px",
                                                        height: "32px",
                                                        fontSize: "14px",
                                                        padding: "4px 8px",
                                                    }}
                                                /> */}
              <CustomDatePickingFormat value={date} onChange={handleDateChange} />
            </div>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton onClick={() => setVisible(false)} color="secondary">
            Close
          </CButton>
          <CButton onClick={handleAddNewIncident}>Save Changes</CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default PatientIncidentTreatments
